import React from "react";
import { FormattedMessage } from "react-intl";
import Button from "@components/Button/button";
import styles from "./footerSection.module.scss";

const FooterSection = ({ locale }) => (
  <section className={styles.countryFooterSection}>
    <Button
      href={`/accommodation/`}
      text={<FormattedMessage id="cities_page.footer.back_to_all_countries" />}
      locale={locale}
    />
  </section>
);

export default FooterSection;
